import { createEvent, sample } from 'effector'
import { model as sessionModel } from '~/entities/session'
import { appearanceFeature } from '~/features/appearance'
import { dynamicModuleModel } from '~/widgets/DynamicModule'

export const init = createEvent<{
  identifier: string
  query: URLSearchParams
}>()

export const left = createEvent()

sample({
  clock: init,
  fn: (params) => params.identifier,
  target: appearanceFeature.setIdentifier,
})

//
// rows
//

sample({
  clock: init,
  target: dynamicModuleModel.initModule,
})

sample({
  clock: left,
  source: appearanceFeature.$currentIdentifier,
  fn: (identifier) => (identifier ? { identifier } : { identifier: '' }),
  target: dynamicModuleModel.leaveModule,
})

sample({
  clock: sessionModel.$session,
  target: dynamicModuleModel.resetStructure,
})
